import * as ko from 'knockout';
import 'knockout.validation';

export class BillingDetails implements IBillingDetailsMapped {
    FirstName: KnockoutObservable<string>;
    LastName: KnockoutObservable<string>;
    Email: KnockoutObservable<string>;
    PhoneNumber: KnockoutObservable<string>;
    PostCode: KnockoutObservable<string>;
    AddressLine1: KnockoutObservable<string>;
    City: KnockoutObservable<string>;
    Region: KnockoutObservable<string>;
    Country: KnockoutObservable<string>;

    constructor() {
        this.FirstName = ko.observable("");
        this.LastName = ko.observable("");
        this.Email = ko.observable("");
        this.PhoneNumber = ko.observable("");
        this.PostCode = ko.observable("");
        this.AddressLine1 = ko.observable("");
        this.City = ko.observable("");
        this.Region = ko.observable("");
        this.Country = ko.observable("");
    }

    // reset all observable values to empty strings
    clearValues(): void {
        for (const propertyName in this) {
            if (ko.isObservable(this[propertyName])) {
                const observable = this[propertyName] as KnockoutObservable<string>;
                observable("");
                observable.clearError();
            }
        }
    }
}

export interface IBillingDetailsMapped {
    FirstName: KnockoutObservable<string>;
    LastName: KnockoutObservable<string>;
    Email: KnockoutObservable<string>;
    PhoneNumber: KnockoutObservable<string>;
    PostCode: KnockoutObservable<string>;
    AddressLine1: KnockoutObservable<string>;
    City: KnockoutObservable<string>;
    Region: KnockoutObservable<string>;
    Country: KnockoutObservable<string>;

    clearValues(): void;
}

export interface IBillingDetails {
    FirstName: string;
    LastName: string;
    Email: string;
    PhoneNumber: string;
    PostCode: string;
    AddressLine1: string;
    City: string;
    Region: string;
    Country: string;
}